export var RenderState;
(function (RenderState) {
    RenderState["None"] = "NONE";
    RenderState["Initial"] = "INITIAL";
    RenderState["Running"] = "RUNNING";
    RenderState["Finished"] = "FINISHED";
    RenderState["Failed"] = "FAILED";
})(RenderState || (RenderState = {}));
//# sourceMappingURL=RenderState.type.js.map